module.exports = __webpack_public_path__ + "img/logo_without_background.08f8178c.png";